import React, { useEffect, useRef, useState } from 'react';

import { cropImageFromURL } from '../utils';
import PlaceableHDAItem from './PlaceableHDAItem';

import { Box, CircularProgress } from '@mui/material';

const FloorPlanHDAImage = ({
  dropRef,
  imageData,
  boundingRef,
  HDAs,
  setScaledDimensions,
  isImageLoaded,
  handleClickNewHDACreate,
  setIsImageLoaded,
  markerSize,
  hdaTypesInFp,
}) => {
  const [actualImageURL, setActiveImageUrl] = useState('');
  const coordsForHDARef = useRef(null);

  useEffect(() => {
    if (imageData?.cropData) {
      cropImageFromURL(imageData.url, imageData.cropData, setActiveImageUrl);
    } else if (imageData?.url) {
      setActiveImageUrl(imageData.url);
    }
  }, [imageData?.url]);

  const resizeHandler = () => {
    if (boundingRef.current) {
      setScaledDimensions({
        width: boundingRef.current.getBoundingClientRect().width,
        height: boundingRef.current.getBoundingClientRect().height,
      });
    }
  };

  useEffect(() => {
    resizeHandler();
  }, [imageData]);

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);

    const fpBox = document.getElementById('fp-box');
    fpBox.addEventListener(`mousedown`, (e) => {
      coordsForHDARef.current = {
        x: e.offsetX,
        y: e.offsetY,
      };
      setTimeout(() => {
        coordsForHDARef.current = null;
      }, 200);
    });
    fpBox.addEventListener(`mouseup`, (e) => {
      if (coordsForHDARef.current) {
        const { x, y } = coordsForHDARef.current;
        if (x === e.offsetX && y === e.offsetY) {
          coordsForHDARef.current = null;
          handleClickNewHDACreate(x, y);
        }
      }
    });
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  const renderScaledPoints = () => {
    if (isImageLoaded) {
      return (
        <>
          {HDAs.map((hda) => (
            <PlaceableHDAItem
              key={hda.id}
              colorIndex={hdaTypesInFp.indexOf(hda.type) % 10}
              hda={hda}
              markerSize={markerSize}
            />
          ))}
        </>
      );
    } else {
      return <CircularProgress />;
    }
  };

  return (
    <Box position="relative">
      <img
        src={actualImageURL}
        alt="active floorplan"
        width="100%"
        height="100%"
        onLoad={() => {
          if (boundingRef.current) {
            setScaledDimensions({
              width: boundingRef.current.getBoundingClientRect().width,
              height: boundingRef.current.getBoundingClientRect().height,
            });
            setIsImageLoaded(true);
          }
        }}
        style={{
          visibility: isImageLoaded ? 'visible' : 'hidden',
        }}
        ref={boundingRef}
      />
      <Box
        id="fp-box"
        ref={dropRef}
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={50}
      >
        {renderScaledPoints()}
      </Box>
    </Box>
  );
};

export default FloorPlanHDAImage;
